// A light-weight alternative to grammar lookup tables
function pluralize(singular, pluralOption) {
  const plural = pluralOption || singular + 's'
  return function (count) {
    if (count === 1) {
      return singular
    }
    return plural
  }
}

// https://en.wikipedia.org/wiki/International_System_of_Units#Prefixes
const SI_UNITS = ['', 'k', 'M', 'G', 'T', 'P', 'E']

function formatCount(count) {
  const unitTier = Math.min(
    Math.floor(Math.log10(Math.abs(count)) / 3),
    SI_UNITS.length - 1
  )
  if (!count || !unitTier) {
    return `${count}`
  }
  const unitScale = Math.pow(10, unitTier * 3)
  // Work-around undesirable rounding behavior of Number.prototype.toFixed
  const formatted = `${count / unitScale}`
  .replace(/^([0-9]{2,})\.[0-9]+$/, '$1')
  .replace(/(\.[0-9])[0-9]*$/, '$1')
  .replace(/\.0$/, '')
  return formatted + SI_UNITS[unitTier]
}

module.exports = {
  formatCount,
  pluralize
}
